module.exports = __webpack_public_path__ + "img/dummy-accred-photo.0dbf5cf1.png";